export default "__VITE_ASSET__AdXQ3wFz__"